/** Spanish for the My Hub hubDialog area. Keys are the exact English strings the UI renders. */
const hubDialog = {
  // ---- ClinicHubDialog: header
  'Last changed by {name}, {date}': 'Último cambio por {name}, {date}',
  'Not changed yet': 'Sin cambios todavía',
  'Close': 'Cerrar',

  // ---- Ordering
  'Ordering': 'Envío de pedidos',
  'Clinic logins can submit orders': 'Los inicios de sesión de la clínica pueden enviar pedidos',
  'Off: they still see every order; you place orders for them.':
    'Desactivado: siguen viendo todos los pedidos; usted realiza los pedidos por ellos.',
  'Read-only': 'Solo lectura',
  'Clinic logins can see every order but cannot submit one; the sales representative places orders for this clinic.':
    'Los inicios de sesión de la clínica ven todos los pedidos, pero no pueden enviarlos; el representante de ventas realiza los pedidos de esta clínica.',

  // ---- Products
  'Products this clinic can order': 'Productos que esta clínica puede pedir',
  'All products ({n})': 'Todos los productos ({n})',
  'Only these · {k} selected': 'Solo estos · {k} seleccionados',
  '{k} of {n} selected': '{k} de {n} seleccionados',
  'No products in the catalog.': 'No hay productos en el catálogo.',
  'Filter products': 'Filtrar productos',
  'Filter...': 'Filtrar...',
  'Nothing matches that.': 'Nada coincide con eso.',

  // ---- Credit
  'Credit': 'Crédito',
  'Credit limit': 'Límite de crédito',
  // billing.js already translates this key; a fragment may not disagree with it.
  'Outstanding': 'Pendiente de pago',
  'Available': 'Disponible',
  'Credit used': 'Crédito utilizado',
  'Over limit by {amount}': 'Supera el límite en {amount}',
  'Last changed {date}': 'Último cambio: {date}',
  '{n} invoice past due · {amount}': '{n} factura vencida · {amount}',
  '{n} invoices past due · {amount}': '{n} facturas vencidas · {amount}',
  'Nothing past due': 'Sin facturas vencidas',
  'No credit limit set. An administrator sets it on the Clinics tab.':
    'No se ha establecido un límite de crédito. Un administrador lo establece en la pestaña Clínicas.',
  'Balance not available.': 'Saldo no disponible.',

  // ---- Logins
  'Logins at this clinic': 'Inicios de sesión en esta clínica',
  '{name} (owner)': '{name} (propietario)',
  '{name} (user)': '{name} (usuario)',
  'No logins yet.': 'Aún no hay inicios de sesión.',
  'Inactive': 'Inactivo',

  // ---- Footer + errors
  'Cancel': 'Cancelar',
  'Save changes': 'Guardar cambios',
  'Saving...': 'Guardando...',
  'Could not save those changes': 'No se pudieron guardar esos cambios',

  // ---- Server sentences the dialog may show
  'Pick at least one product, or choose "All products".': 'Elija al menos un producto o seleccione "Todos los productos".',
  'You can only change settings for clinics assigned to you.': 'Solo puede cambiar la configuración de las clínicas que tiene asignadas.',
  'One or more of those products do not exist or are no longer active. Refresh the list and try again.':
    'Uno o más de esos productos no existen o ya no están activos. Actualice la lista e inténtelo de nuevo.',
  'Ordering is turned off for this clinic. Ask your MedEffects sales representative to place the order.':
    'El envío de pedidos está desactivado para esta clínica. Pida a su representante de ventas de MedEffects que realice el pedido.',
  'Clinic not found': 'Clínica no encontrada',
};

export default hubDialog;
